import React from 'react';

const DashStatTile = ({ label, value, accent }) => (
  <div className="dash-stat-tile">
    <span className="dash-stat-tile-label">{label}</span>
    <span className="dash-stat-tile-value" style={accent ? { color: accent } : undefined}>{value}</span>
  </div>
);

export default DashStatTile;
